import { Component, Input, OnInit } from '@angular/core';
import { SmartModalService } from 'app/core/services/smart-modal.service';
import {RxComponent} from '../../../../../../core/components/common/rx.component';
import {CertificatesService} from '../../../certificates.service';
import {ConfigService} from '../../../../../../core/services/config.service';

@Component({
  selector: 'itpx-template-file-form',
  templateUrl: './template-file-form.component.html',
  styleUrls: ['./template-file-form.component.css']
})
export class TemplateFileFormComponent extends RxComponent implements OnInit{
    @Input() data: any;
    initialValue: any;
    public allowedFormats = ['pdf'];
    public maxFileSize = 3000;
    public bucket;
    readonly component: string = 'content-uploader';
    public errorMsg: string;
    public guidelineLink: string = 'https://my.leapest.com/support?articleId=certificate-templates';

    constructor(
        private modalService: SmartModalService,
        private service: CertificatesService,
        private configService: ConfigService
    ) {
        super()
    }

    ngOnInit() {
        this.bucket = this.configService.get('aws').uploadsBucket;
        const formResponse = this.data.form.getRawValue();
        this.initialValue = {
            fileName: formResponse.fileName,
            key: formResponse.key,
            bucket: formResponse.bucket
        };
    }

    public get isDisabled() {
        if (!this.initialValue || !this.data || !this.data.form) {
            return true;
        }
        let { fileName, bucket, key } = this.data.form.getRawValue();
        if (!fileName) {
            return true;
        }
        return fileName === this.initialValue.fileName
            && bucket === this.initialValue.bucket
            && key === this.initialValue.key;
    }

    onCancel() {
        this.data.form.patchValue({
            fileName: this.initialValue.fileName,
            key: this.initialValue.key,
            bucket: this.initialValue.bucket
        })
        this.modalService.close();
    }

    onSubmit() {
        let { fileName, bucket, key } = this.data.form.getRawValue();
        this.modalService.sendResult({ fileName, bucket, key });
    }

    get isTouched() {
        if (!this.initialValue) {
            return false;
        }
        let { fileName, bucket, key } = this.data.form.getRawValue();
        return fileName !== this.initialValue.fileName
                || bucket !== this.initialValue.bucket
                || key !== this.initialValue.key;
    }

    public onSaved(ev) {
        const { fileName, bucket, key } = ev.data;
        this.service.validateCertificate(key, bucket).subscribe(res => {
            this.data.form.patchValue({ fileName, bucket, key });
        }, err => {
            let parsedError = JSON.parse(err._body).error;
            if (parsedError.code[0] == '400') {
                this.errorMsg = parsedError.message;
            }
        })
    }

    public uploadInProgress(event) {
        if (event) {
            this.errorMsg = null;
        }
    }

    public deleteFile() {
        this.data.form.patchValue({ fileName: null, bucket: null, key: null });
    }
}



// WEBPACK FOOTER //
// ./src/app/organization/components/certificates/components/details/template-file-form/template-file-form.component.ts